// Mirror of blocks-backend/controllers/landmark/dynamicEventTranslator.js
// extractTranslatable() — used by the dashboard to detect, before saving,
// that the English content has changed since a translation was generated.
// Field list must stay in sync with the backend.

const SCALARS = [
  "heroHeading",
  "heroSubHeading",
  "heroText",
  "expectText",
  "afterSubmittedText",
  "eventDate",
  "eventTime",
  "eventLocationShort",
  "eventLocationFull",
  "eventSpeaker",
  "customInputLabel",
  "rsvpButtonText",
  "registerButtonText",
  "logoCarouselSidebarHeading",
];

const str = (v) => (typeof v === "string" ? v : "");

export const extractTranslatable = (pageContent = {}) => {
  const pc = pageContent || {};
  const out = {};
  for (const key of SCALARS) {
    if (str(pc[key]).trim().length) out[key] = pc[key];
  }
  if (Array.isArray(pc.expectBullets) && pc.expectBullets.length) {
    out.expectBullets = pc.expectBullets.map(str);
  }
  if (Array.isArray(pc.contentSections) && pc.contentSections.length) {
    out.contentSections = pc.contentSections.map((s) => ({
      heading: str(s?.heading),
      text: str(s?.text),
    }));
  }
  if (Array.isArray(pc.faqs) && pc.faqs.length) {
    out.faqs = pc.faqs.map((f) => ({
      question: str(f?.question),
      answer: str(f?.answer),
    }));
  }
  if (Array.isArray(pc.speakerProfiles) && pc.speakerProfiles.length) {
    out.speakerProfiles = pc.speakerProfiles.map((s) => ({
      heading: str(s?.heading),
      title: str(s?.title),
      bio: str(s?.bio),
    }));
  }
  if (Array.isArray(pc.customQuestions) && pc.customQuestions.length) {
    out.customQuestions = pc.customQuestions.map((q) => ({
      questionLabel: str(q?.questionLabel),
      options: Array.isArray(q?.options) ? q.options.map(str) : [],
    }));
  }
  return out;
};

// Cheap, deterministic fingerprint of the translatable content. Only used
// for "has it changed since load" comparisons, never compared to the
// backend's sha1.
export const translatableFingerprint = (pageContent = {}) =>
  JSON.stringify(extractTranslatable(pageContent));

export const TRANSLATABLE_FIELD_LABELS =
  "headings, intro and body text, agenda bullets, content sections, FAQs, date / time / location, speaker bios, custom questions and button text";
